import { render, staticRenderFns } from "./Detailppkprovinsi.vue?vue&type=template&id=71131a0a"
import script from "./Detailppkprovinsi.vue?vue&type=script&lang=js"
export * from "./Detailppkprovinsi.vue?vue&type=script&lang=js"
import style0 from "./Detailppkprovinsi.vue?vue&type=style&index=0&id=71131a0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports